import Pivot from '../Pivot';
import Schedule from '../Schedule';
import Table from '../Table';
import RevenueMonthlyBudgetPivot from './RevenueMonthlyBudgetPivot';
import SitemapLink from './SitemapLink';
import TimeMonthlyBudgetPivot from './TimeMonthlyBudgetPivot';
import TimesheetSummaryPivot from './TimesheetSummaryPivot';
import TrackTimePreflight from './track-time/TrackTimePreflight';
import TrackTimeResult from './track-time/TrackTimeResult';
import TrackTimeSuggestions from './track-time/TrackTimeSuggestions';

// Registry: tool name → { view type (as emitted by the LLM) → renderer component }.
//
// View types: 'table' | 'pivot' | 'chart' | 'schedule' are layout primitives; 'component' is the generic
// "render this tool's result through its own component" key, for output that isn't a generic table/pivot.
// The LLM emits `{ type, callId }` to place a result; this registry maps it to a renderer component. A tool
// with a bespoke view points its 'component' at a dedicated component, which may itself reuse a shared layer
// (e.g. TrackTimePreflight/TrackTimeResult reuse ConfirmationForm, the way a specialized pivot reuses Pivot).
const renderers = {
  'project-revenue-monthly-budget': { pivot: RevenueMonthlyBudgetPivot },
  'project-time-monthly-budget': { pivot: TimeMonthlyBudgetPivot },
  'resource-schedule': { schedule: Schedule },
  'sitemap-url-builder': { component: SitemapLink },
  'timesheet-summary': { pivot: TimesheetSummaryPivot },
  'track-time-suggestions': { component: TrackTimeSuggestions },
  'track-time-preflight': { component: TrackTimePreflight },
  'track-time': { component: TrackTimeResult },
};

// Default component per view type — used when a tool has no registered override. 'component' has no generic
// default (it's always tool-specific); schedule falls back to Table.
const DEFAULT_RENDERERS = {
  pivot: Pivot,
  table: Table,
  schedule: Table,
};

export default renderers;

export function resolveRenderer(toolName, viewType) {
  return renderers[toolName]?.[viewType] ?? DEFAULT_RENDERERS[viewType] ?? null;
}
